import { useEffect, Fragment } from "react";
import { useLocation } from "react-router-dom";
import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import RenderMathQuestion from "../../../../../../shared/components/RenderMathQuestion/RenderMathQuestion";
import { optionLables } from "../..";
import "./QuestionCard.css";
import QuestionHeader from "../../Layout/QuestionHeader/QuestionHeader";
import images from "../../../../../../utilities/images/images";
import {
  saveAnswerRequest,
  updateQuestionStatus,
} from "../../../../../../redux/exam/examSlice";
import { getBackendQuestionStatus } from "../../../../../../shared/utilities/helpers/examQuestionStatus";
import QuestionText from "../../../../../analytics/components/QuestionWise/QuestionText";

const QuestionCard = () => {
  const { selector, dispatch } = useAppHooks();
  const location = useLocation();
  const state = selector((state) => state.examSlice);

  const currentLang = state?.currentLang || "en";
const questionPayload = state?.question;
const question = Array.isArray(questionPayload)
  ? questionPayload[0]
  : Array.isArray(questionPayload?.data)
  ? questionPayload.data[0]
  : questionPayload?.data || questionPayload;
  const isAdaptiveMode = location?.state?.useAdaptiveTestScreen === true;
  const isPracticeMode =
    !isAdaptiveMode && state?.testDetails?.practiceMode === "practice";
  const isPracticeGamified =
    isPracticeMode && state?.testDetails?.gamificationOn === true;

  const isParagraphType =
    String(question?.type || "")
      .toLowerCase()
      .includes("paragraph") ||
    String(question?.type_id || "").trim() === "4";

  const renderedQuestionText =
    currentLang === "en"
      ? isParagraphType
        ? question?.p_text ?? question?.q_text
        : question?.q_text
      : isParagraphType
      ? question?.p_text_hindi ?? question?.q_text_hindi
      : question?.q_text_hindi;

  const renderedQText =
    currentLang === "en" ? question?.q_text : question?.q_text_hindi;

  // Mark current question as active/current
  useEffect(() => {
    if (question?.qid) {
      dispatch(
        updateQuestionStatus({
          qid: question.qid,
          makeCurrent: true,
        })
      );
    }
  }, [dispatch, question?.qid]);
if (!question) {
  return null;
}
  const currentQ =
  state.questionsData?.find(
    (q) => q.qid === question?.qid
  ) || {};
  const answerType = Number(question?.answer_type_id);
  const answerKey = String(currentQ?.answer ?? question?.answer ?? "").trim();
  const typedIntegerAnswer = String(
    currentQ?.integerAnswer ?? currentQ?.integer_Answer ?? ""
  ).trim();
  const isIntegerAnswerCorrect =
    typedIntegerAnswer !== "" && answerKey !== "" && typedIntegerAnswer === answerKey;
  const hasCheckedInteger = currentQ?.integerChecked === true;
  const hasCheckedAnswer = currentQ?.answerChecked === true;
  const isIntegerLocked = isPracticeGamified
    ? hasCheckedInteger
    : isPracticeMode && hasCheckedAnswer;
  const hasAnyOptionSelected =
    answerType === 2
      ? Array.isArray(currentQ?.selectedOption) &&
        currentQ.selectedOption.length > 0
      : currentQ?.selectedOption !== null &&
        currentQ?.selectedOption !== undefined &&
        currentQ?.selectedOption !== "";
  const isMultiCorrectGamified =
    isPracticeGamified && answerType === 2;
  const isOptionLocked = isPracticeGamified
    ? isMultiCorrectGamified
      ? hasCheckedAnswer
      : hasAnyOptionSelected
    : isPracticeMode && hasCheckedAnswer;

  const saveCurrentAnswerForGamification = ({
    selectedOption,
    integerAnswer,
  } = {}) => {
    if (!isPracticeGamified || !question?.qid) return;

    dispatch(
      saveAnswerRequest({
        qid: question.qid,
        paper_id: question.paper_id,
        paper_type: state?.testDetails?.paperType,
        test_id: state?.testDetails?.testId,
        set_id: state?.selectedSetId,
        time: currentQ?.time_taken ?? currentQ?.time ?? 0,
        triggerStreak: true,
        option_id:
          answerType === 1 || answerType === 2 ? selectedOption ?? "" : "",
        option_int: answerType === 3 ? integerAnswer ?? "" : "",
        question_status: getBackendQuestionStatus({
          ...currentQ,
          selectedOption,
          integerAnswer,
        }),
        skipAdvance: true,
      })
    );
  };

  const handleOptionClick = (optionId) => {
  const currentQid = question.qid;

  // MULTIPLE CORRECT
  if (answerType === 2) {
    const existingSelections = Array.isArray(currentQ.selectedOption)
      ? currentQ.selectedOption
      : [];
    const optionIdKey = String(optionId);

    const updatedSelections = existingSelections.some(
      (id) => String(id) === optionIdKey
    )
      ? existingSelections.filter((id) => String(id) !== optionIdKey)
      : [...existingSelections, optionId];

    dispatch(
      updateQuestionStatus({
        qid: currentQid,
        selectedOption: updatedSelections,
      })
    );
    if (!isMultiCorrectGamified) {
      saveCurrentAnswerForGamification({ selectedOption: updatedSelections });
    }
  }
// SINGLE CORRECT
  else {
    dispatch(
      updateQuestionStatus({
        qid: currentQid,
        selectedOption: optionId,
      })
    );
    saveCurrentAnswerForGamification({ selectedOption: optionId });
  }
};

  const handleIntegerInputChange = (e) => {
    const value = e.target.value;
    // Allow decimal inputs like 0.5 (single dot only).
    if (/^\d*\.?\d*$/.test(value)) {
      dispatch(
        updateQuestionStatus({
          qid: question.qid,
          integerAnswer: value,
          integerChecked: false,
        })
      );
    }
  };

  const buildQuestionTextData = () => {
    const enrichedOptions = (optionsArray || []).map((opt) => {
      const optionId = String(opt.option_id);
      const isMultiple = answerType === 2;
      const isSelectedByUser = isMultiple
        ? Array.isArray(currentQ?.selectedOption) &&
          currentQ.selectedOption.some((id) => String(id) === optionId)
        : String(currentQ?.selectedOption) === optionId;

      return {
        ...opt,
        is_user_correct_ans: isSelectedByUser ? 1 : 0,
      };
    });

    return {
      ...question,
      option: enrichedOptions,
    };
  };

let optionsArray = [];

if (Array.isArray(question?.option) && question.option.length > 0) {
  optionsArray = question.option;
} else {
  const rawOption =
    currentLang === "en"
      ? question?.eng_option
      : question?.h_option;

  if (rawOption) {
    try {
      optionsArray = JSON.parse(rawOption);
    } catch (e) {
      console.log("Option parse error", e);
      optionsArray = [];
    }
  }
}
  return (
    <div className="exam__question_card">
      <QuestionHeader /> 

      <div className="exam__question_card__question">
        {question && (
          <>
            <RenderMathQuestion question={renderedQuestionText} />
            {isParagraphType && renderedQText && (
              <div style={{ marginTop: 12 }}>
                <RenderMathQuestion question={renderedQText} />
              </div>
            )}
          </>
        )}
      </div>

      <div className="exam__question_card__options">
      {[1, 2].includes(answerType) ? (
            <Fragment>
            {optionsArray.map((opt, index) => {
            const isMultiple = answerType === 2;
           const isSelected = isMultiple
      ? Array.isArray(currentQ.selectedOption) &&
      currentQ.selectedOption.some((id) => String(id) === String(opt.option_id))
     : String(currentQ.selectedOption) === String(opt.option_id);
            const isCorrectOption = opt.is_correct === 1;

            const showResult = isMultiCorrectGamified
              ? hasCheckedAnswer
              : isPracticeGamified
              ? hasAnyOptionSelected
              : isPracticeMode && hasCheckedAnswer;

            let optionClass = "";
            let labelClass = "";
            let statusBadgeText = "";
            let statusBadgeVariant = "";
            let statusBadgeIcon = "";

            if (showResult) {
              if (isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
                statusBadgeText = "Your answer";
                statusBadgeVariant = "correct";
                statusBadgeIcon = images.tick_icon;
              } else if (isSelected && !isCorrectOption) {
                optionClass = "option-wrong";
                labelClass = "label-wrong";
                statusBadgeText = "Your answer";
                statusBadgeVariant = "wrong";
                statusBadgeIcon = images.Wrong;
              } else if (!isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
                statusBadgeText = "Right answer";
                statusBadgeVariant = "correct";
                statusBadgeIcon = images.tick_icon;
              }
            } else if (isSelected) {
              optionClass = "selected";
              labelClass = "selected-label";
            }

            return (
              <div
                key={opt.option_id}
                className={`exam__question_card__option ${optionClass} ${
                  isOptionLocked ? "option-disabled" : ""
                }`}
                onClick={() => {
                  if (isOptionLocked) return;
                  handleOptionClick(opt.option_id);
                }}
              >
                <span
                  className={`exam__question_card__option_label ${
                    labelClass || "not-selected-label"
                  }`}
                >
                  {optionLables[index]}
                </span>

             <RenderMathQuestion
  question={
    currentLang === "en"
      ? opt.option
      : opt.option_hindi ?? opt.option
  }
/>
                {statusBadgeText && (
                  <span
                    className={`exam__question_card__option_status ${statusBadgeVariant}`}
                  >
                    <img src={statusBadgeIcon} alt="" />
                    {statusBadgeText}
                  </span>
                )}
              </div>
            );
          })}
            {isMultiCorrectGamified && (
              <button
                type="button"
                className="exam__question_card__check_answer_btn"
                onClick={() => {
                  if (!hasAnyOptionSelected) return;
                  const selections = Array.isArray(currentQ?.selectedOption)
                    ? currentQ.selectedOption
                    : [];
                  dispatch(
                    updateQuestionStatus({
                      qid: question?.qid,
                      answerChecked: true,
                    })
                  );
                  saveCurrentAnswerForGamification({
                    selectedOption: selections,
                  });
                }}
                disabled={isOptionLocked || !hasAnyOptionSelected}
              >
                Check Answer
              </button>
            )}
            </Fragment>
        ) :answerType === 3 ? (
          <div className="exam__question_card__integer_input">
            <input
              type="text"
              value={currentQ?.integerAnswer ?? currentQ?.integer_Answer ?? ""}
              onChange={handleIntegerInputChange}
              placeholder="Type your answer here"
              disabled={isIntegerLocked}
            />
            {isPracticeGamified && (
              <button
                type="button"
                className="exam__question_card__check_answer_btn"
                onClick={() => {
                  const typedAnswer = String(
                    currentQ?.integerAnswer ?? currentQ?.integer_Answer ?? ""
                  ).trim();
                  if (!typedAnswer) return;
                  dispatch(
                    updateQuestionStatus({
                      qid: question?.qid,
                      integerChecked: true,
                    })
                  );
                  saveCurrentAnswerForGamification({
                    integerAnswer: typedAnswer,
                  });
                }}
                disabled={
                  isIntegerLocked ||
                  !String(
                    currentQ?.integerAnswer ?? currentQ?.integer_Answer ?? ""
                  ).trim()
                }
              >
                Check Answer
              </button>
            )}
            {isPracticeMode && hasCheckedInteger && answerKey && (
              <div className="exam__question_card__integer_answer_result">
                <div className="exam__question_card__integer_correct_answer_block">
                  <div
                    className={`label your-answer ${
                      isIntegerAnswerCorrect ? "correct" : "wrong"
                    }`}
                  >
                    Your answer: {typedIntegerAnswer || "-"}
                  </div>
                  <div className="label correct-answer">Correct answer is </div>
                  <div className="value">{answerKey}</div>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>
      {isPracticeMode && currentQ?.showSolution === true && (
        <QuestionText data={buildQuestionTextData()} solutionOnly />
      )}
    </div>
  );
};

export default QuestionCard;